module.exports = __webpack_public_path__ + "img/pgn06.fe2494f3.png";